/**
 * AuditLogs Page - "Journal d'audit & sécurité"
 */

import React from 'react';
import AuditSecurityPage from '../../components/rbac/AuditSecurityPage';

const AuditLogs = () => <AuditSecurityPage />;

export default AuditLogs;
